module.exports = __webpack_public_path__ + "static/houston-931e577fe07cfc21186729e6b037a6b9.png";